var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        "nudge-bottom": "8",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "BaseButton",
                _vm._g(
                  _vm._b(
                    { attrs: { secondary: "", text: "", sm: "" } },
                    "BaseButton",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("icon-svg", {
                    attrs: { name: "mdi-plus", size: 16, color: "primary" }
                  }),
                  _vm._v(" Benchmarks ")
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "bg-white benchmarks-menu__panel" },
        [
          _c(
            "div",
            { staticClass: "benchmarks-menu__body" },
            [
              _vm.clienteBenchmarkMeta
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "", "max-width": "260" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "div",
                                  _vm._g(_vm._b({}, "div", attrs, false), on),
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        label:
                                          _vm.clienteBenchmarkMeta.label ||
                                          "Meu Benchmark",
                                        value: _vm.CLIENT_BENCHMARK_KEY,
                                        color: "primary",
                                        dense: "",
                                        "hide-details": ""
                                      },
                                      on: { change: _vm.onChange },
                                      model: {
                                        value: _vm.selectedProxy,
                                        callback: function($$v) {
                                          _vm.selectedProxy = $$v
                                        },
                                        expression: "selectedProxy"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2965409367
                      )
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " Benchmark padrão deste cliente. Para alterar, edite os dados cadastrais do cliente. "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.clienteBenchmarkMeta
                ? _c("v-divider", { staticClass: "my-2" })
                : _vm._e(),
              _vm._l(_vm.benchmarks, function(bench) {
                return _c(
                  "v-tooltip",
                  {
                    key: bench.id,
                    attrs: {
                      bottom: "",
                      disabled: _vm.availableBenchmarkNames.has(bench.nome)
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "div",
                                _vm._g(_vm._b({}, "div", attrs, false), on),
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: bench.nome,
                                      value: bench.id,
                                      disabled: !_vm.availableBenchmarkNames.has(
                                        bench.nome
                                      ),
                                      color: "primary",
                                      dense: "",
                                      "hide-details": ""
                                    },
                                    on: { change: _vm.onChange },
                                    model: {
                                      value: _vm.selectedProxy,
                                      callback: function($$v) {
                                        _vm.selectedProxy = $$v
                                      },
                                      expression: "selectedProxy"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [_c("span", [_vm._v("Sem dados nessa visualização")])]
                )
              })
            ],
            2
          ),
          _vm.showAddBenchmark
            ? [
                _c("v-divider"),
                _c(
                  "div",
                  {
                    staticClass:
                      "benchmarks-menu__footer d-flex align-center justify-center az-gap-small pa-3"
                  },
                  [
                    _c(
                      "BaseButton",
                      {
                        attrs: {
                          secondary: "",
                          text: "",
                          small: "",
                          "fit-content": "",
                          "min-width": "fit-content"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("reset")
                          }
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-refresh",
                            size: 16,
                            color: "primary"
                          }
                        }),
                        _vm._v(" Resetar ")
                      ],
                      1
                    ),
                    _c(
                      "BaseButton",
                      {
                        attrs: {
                          primary: "",
                          outline: "",
                          small: "",
                          "fit-content": "",
                          "min-width": "fit-content"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("add-benchmark")
                          }
                        }
                      },
                      [_vm._v(" Adicionar benchmark ")]
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }